export const DEFAULT_HISTORY_MONTHS = 3;
export const WORK_WEEK_LAST_DAY = 4;
